<template>
  <div class="RPIndexOther">
    <div class="RP-Master">
      <div class="report-head">
        <div class="report-head-info">
          <img :src="Global.companyLogo" alt="" />
          <div class="head-info-name">{{ Global.systemNM == '' ? '心理防护系统' : Global.systemNM }}</div>
        </div>
        <div class="report-head-menu">
          <ul class="report-head-menu-ul">
            <li @click="goHome">
              <img src="../../assets/img/ReportData/reportdata-relogin.png" alt="" />
              <span>回到主页</span>
            </li>
            <li @click="reLogin">
              <img src="../../assets/img/ReportData/reportdata-relogin.png" alt="" />
              <span>重新登录</span>
            </li>

            <li @click="modify">
              <img src="../../assets/img/ReportData/reportdata-relogin.png" alt="" />
              <span>修改密码</span>
            </li>

          </ul>
          <div class="system-user">{{ Global.realName }}</div>
        </div>
      </div>
      <div class="report-main">
        <!-- 左侧导航 -->
        <LeftMenu ref="myLeftMenu" />
        <div class="report-content">
          <div class="grid-content bg-purple-dark">
            <RPTabList />
          </div>
          <div class="grid-frame">
            <router-view />
          </div>
        </div>
      </div>
    </div>

    <el-dialog  title="提示" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" :rules="rules"
        style="width: 50%; margin: auto;">
        <el-form-item :label="$t('original.languages245')" prop="lpass">
          <el-input type="password" v-model="ruleForm.lpass" :placeholder="$t('original.languages4')" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item :label="$t('original.languages246')" prop="newpass">
          <el-input type="password" v-model="ruleForm.newpass" :placeholder="$t('original.languages4')" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('original.languages247')" prop="newpass2">
          <el-input type="password" v-model="ruleForm.newpass2" :placeholder="$t('original.languages4')"
            maxlength="20"></el-input>
        </el-form-item>
      </el-form>
      <el-button @click="tj('ruleForm')" style="margin-left: 49%;" type="primary">
          {{ $t('original.save') }}
      </el-button>
    </el-dialog>

  </div>
</template>
<script>
import LeftMenu from './RPLeftMenu';
import RPTabList from './RPTabList';

export default {
  data() {
    return {
      MyPMenuID: '',
      dialogVisible: false,
      ruleForm: {
        lpass: '',
        newpass: '',
        newpass2: '',
      },
      rules: {
        lpass: [
          {
            required: true,

            message: '请输入原始密码!',
            trigger: 'blur',
          },
        ],
        newpass: [
          {
            required: true,
            pattern: /(?!\d+$)(?!^[a-zA-Z]+$)(?!^[_#@]+$).{8,20}/,
            message: '8至20位，包含数字、英文字母',
            trigger: 'blur',
          },
        ],
        newpass2: [
          {
            required: true,
            pattern: /(?!\d+$)(?!^[a-zA-Z]+$)(?!^[_#@]+$).{8,20}/,
            message: '8至20位，包含数字、英文字母',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  components: {
    LeftMenu,
    RPTabList,
  },
  created() { },
  methods: {
    reLogin: function () {
      this.$router.push('/login');
    },
    goHome: function () {
      this.$router.push('/ReportData/RPHome');
    },
    modify() {
      this.dialogVisible = true
    },
    tj(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('User/GetChangePassword', {
            FistPwd: this.ruleForm.newpass,
            LastPwd: this.ruleForm.newpass2,
            Pwd: this.ruleForm.lpass,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message)
              sessionStorage.removeItem('username')
              this.$router.push('/login')
            } else {
              this.Global.request_failure(res.Message)
            }
          })
        } else {
          this.Global.request_failure('信息填写有误!')
          return false
        }
      })
    },
  },
  mounted() {
    this.MyPMenuID = this.$route.query.MyPMenuID;
    if (this.MyPMenuID == undefined || this.MyPMenuID == null) {
      if (sessionStorage.getItem("MyPMenuID") != undefined && sessionStorage.getItem("MyPMenuID") != null) this.MyPMenuID = sessionStorage.getItem("MyPMenuID")
      else this.MyPMenuID = ''
    }
    sessionStorage.setItem("MyPMenuID", this.MyPMenuID)
    this.$refs.myLeftMenu.SetPMenuID(this.MyPMenuID)
  },
};
</script>
<style>
.RPIndexOther {
  height: 100%;
}

.RPIndexOther .rp-table_btn {
  padding: 5px 10px;
  color: rgba(36, 153, 255, 1);
  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;
}

.RPIndexOther .el-container {
  padding: 10px;
  height: 100%;
}

.RPIndexOther .RP-Master {
  margin: 0 0;
  padding: 0 0;
  height: 100%;
}

.RPIndexOther .report-head {
  height: 70px;
  width: 100%;
  background-image: url('../../assets/img/ReportData/RPMain-BG-Header.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.RPIndexOther .report-main {
  width: 100%;
  height: calc(100% - 70px);
}

.RPIndexOther .report-head-info {
  float: left;
  width: 50%;
  height: 70px;
  line-height: 70px;
  margin-left: 2%;
}

.RPIndexOther .report-head-info img {
  float: left;
  margin: 10px 5px 5px 5px;
  width: 50px;
}

.RPIndexOther .report-head-info .head-info-name {
  float: left;
  margin-left: 20px;
  font-size: 35px;
  font-weight: bold;
  color: white;
  letter-spacing: 3px;
  font-family: '华文隶书';
}

.RPIndexOther .report-head-menu {
  float: right;
  margin-top: 5px;
  margin-right: 2%;
  text-align: right;
}

.RPIndexOther .report-head-menu-ul {
  float: right;
  margin-top: 5px;
  color: white;
  cursor: pointer;
}

.RPIndexOther .report-head-menu .system-user {
  color: rgb(197, 98, 5);
  font-size: 12px;
  line-height: 30px;
}

.RPIndexOther .report-head-menu-ul li {
  float: left;
}

.RPIndexOther .report-head-menu-ul img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 3px;
}

.RPIndexOther .ReportDataMater-gray {
  border: 1px solid #e7e7e7;
  height: calc(100% - 2px) !important;
  overflow: auto;
  background-color: rgb(235, 236, 237);
}

.RPIndexOther .ReportDataMater-white {
  background-color: white;
}

.RPIndexOther .RDMater-gray-header {
  background: white;
  overflow: hidden;
  height: auto !important;
}

.RPIndexOther .RDMaster-Query-Option {
  float: right;
}

.RPIndexOther .RDMater-gray-main {
  margin-top: 10px;
  background: rgba(255, 255, 255, 1);
}

.RPIndexOther .must-tip {
  vertical-align: middle;
  color: red;
}

/*弹框样式定义  -------开始*/
.RPIndexOther .dialog-second-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.RPIndexOther .dialog-content {
  overflow: auto;
  border: 1px solid #cec3c0;
  padding: 10px;
  box-shadow: 0px 0px 5px #d9d1d0;
  height: calc(100% - 64px);
}

.RPIndexOther .dialog-content table {
  width: 100%;
}

.RPIndexOther .dialog-content tr {
  height: 50px;
}

.RPIndexOther .dialog-title {
  width: 30%;
  text-align: right;
  padding-right: 20px;
}

.RPIndexOther .dialog-cnt {
  padding-left: 20px;
  padding-right: 20px;
}

.RPIndexOther .dialog-content input[type='text'] {
  width: 90%;
}

.RPIndexOther .dialog-content .el-select,
.RPIndexOther .dialog-content .el-date-editor {
  width: 90%;
}

.RPIndexOther .dialog-content .el-select input[type='text'],
.RPIndexOther .dialog-content .el-date-editor input[type='text'] {
  width: 100%;
}

.RPIndexOther .dialog-option {
  margin-top: 15px;
  text-align: center;
}

.RPIndexOther .dialog-cascader {
  width: 100%;
}

.RPIndexOther .grid-frame {
  margin: 15px;
  padding: 10px;
  height: calc(100% - 90px);
  background-color: #fff;
}

.RPIndexOther .dialog-tip {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
}

.grid-content {
  background-color: #fff;
  height: 40px;
}

.grid-content .el-tabs__header {
  margin: 0px !important;
  padding-left: 15px !important;
}

.grid-content .el-tabs__item {
  height: 35px;
  line-height: 35px;
}

/*弹框样式定义  -------结束*/

/* .el-button--primary:focus,
.el-button--primary:hover {
  border: 1px solid rgb(73, 80, 90);
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #777a71;
  border-color: #777a71;
} */

.RPIndexOther .sw-load {
  width: 260px;
  height: 80px;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
}

.RPIndexOther .sw-load-tip {
  height: 50px;
  line-height: 50px;
  color: rgb(78, 78, 78);
}

.RPIndexOther .item-time {
  font-size: 14px;
}

.RPIndexOther .export-bar {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  font-size: 18px;
}

.RPIndexOther .export-bar-left {
  float: left;
  width: 50%;
  text-align: center;
  color: rgb(8, 95, 226);
  text-decoration: underline;
}

.RPIndexOther .export-bar-right {
  float: right;
  width: 50%;
  text-align: center;
  color: rgb(8, 95, 226);
  text-decoration: underline;
}

.RPIndexOther .export-bar-left:hover,
.RPIndexOther .export-bar-right:hover {
  cursor: pointer;
}

.RPIndexOther .el-cascader {
  width: 90%;
}

.RPIndexOther .el-cascader .el-input .el-input__inner {
  width: 100%;
}
</style>
